import { css } from '@emotion/react'
import clsx from 'clsx'
import * as React from 'react'

import type { StyleProps } from '@/types'

import S from './Toggle.style'

type Props = {
  id?: string
  checked: boolean
  disabled?: boolean
  onClick: React.MouseEventHandler<HTMLButtonElement>
  size?: 'default' | 'small'
  'aria-label'?: string
}

export const Toggle = ({
  id,
  checked,
  onClick,
  style,
  className,
  disabled,
  size = 'default',
  'aria-label': ariaLabel,
}: Props & StyleProps) => {
  return (
    <button
      {...{ id, onClick, style, className }}
      aria-label={ariaLabel}
      aria-pressed={checked}
      disabled={disabled}
      css={css`
        :disabled {
          cursor: not-allowed;
        }
      `}
    >
      <div
        className={clsx(checked && 'checked', disabled && 'disabled', size)}
        css={[S.basic, size === 'small' ? S.small : S.default, checked ? S.on : S.off]}
      />
    </button>
  )
}
